var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classObj
  }, [_c('div', {
    class: (_vm.prefixCls + "-modal-dialog"),
    style: ({
      'width': _vm.width
    })
  }, [_c('div', {
    class: (_vm.prefixCls + "-modal-content")
  }, [_vm._t("header", [_c('div', {
    class: (_vm.prefixCls + "-modal-header")
  }, [_c('button', {
    class: (_vm.prefixCls + "-close"),
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_c('span', [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    class: (_vm.prefixCls + "-modal-title")
  }, [_vm._v(_vm._s(_vm.title))])])]), _vm._v(" "), _c('div', {
    class: (_vm.prefixCls + "-modal-body")
  }, [_vm._t("body")], 2), _vm._v(" "), _c('div', {
    class: (_vm.prefixCls + "-modal-footer")
  }, [_vm._t("footer", [_c('n3-button', {
    nativeOn: {
      "click": function($event) {
        _vm.close($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.getL('cancel')))]), _vm._v(" "), _c('n3-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.confirm($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.getL('confirm')))])])], 2)], 2)])])
}
var staticRenderFns = []
render._withStripped = true
export default { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-54db100c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54db100c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Modal/n3Modal.vue
// module id = 626
// module chunks = 0 1